import React from 'react';
import { CategorizedContent } from './CategorizedContent';
import { HeaderMinimalistic } from './Header';
import { ItemMinimalistic } from './Item';
import { declareWithDefaults } from '../../helpers/typescript';
import { CategorizedContentProps } from './typesCategorizedContent';

/* Types */
export type CategorizedContentMinimalisticProps = CategorizedContentProps;

/* Components and stories */
const CategorizedContentMinimalisticComp: React.FC<CategorizedContentMinimalisticProps> = props => {
  return <CategorizedContent {...props} />;
};

const defaultProps = {
  forceHideHeaders: false,
  headers: { component: HeaderMinimalistic },
  initialListWidth: 190,
  items: { component: ItemMinimalistic },
};
export const CategorizedContentMinimalistic = declareWithDefaults<
  CategorizedContentMinimalisticProps,
  keyof typeof defaultProps
>(CategorizedContentMinimalisticComp, defaultProps);
